import styled from 'styled-components/macro';
import {
  OutlineButton,
  PrimaryButton
} from '../../../../components/ButtonStyles';

export const ApiImportDiv = styled.div`
  p {
    margin-bottom: 20px;
  }
  @media screen and (min-width: 768px) {
    ${OutlineButton} {
      width: 250px;
    }
  }
  h4 {
    margin-bottom: 12px;
  }
  ${PrimaryButton} {
    @media screen and (min-width: 768px) {
      max-width: 310px;
    }
  }
`;

export const ApiKeyDiv = styled.div`
  border: 1px solid ${props => props.theme.mercury};
  padding: 30px;
  margin-bottom: 45px;
  p {
    margin-top: 7px;
    margin-bottom: 0px;
    word-wrap: break-word;
  }
  @media screen and (min-width: 768px) {
    padding: 40px 50px;
    width: 500px;
  }
`;
